import { CicloPlanejamentoParmDTO } from "@/interfaces/crm-planning-cycle";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function listCrmPlannningCyclesByFilters(filters): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_PLANNING_CYCLE, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}
export function getCrmPlanningCycle(id): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.CRM_PLANNING_CYCLE}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function updateCrmPlanningCycle(parm: CicloPlanejamentoParmDTO): Observable<any> {
  return from(apiClient.put(`${ENDPOINTS.CRM_PLANNING_CYCLE}`, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}




